import { useState, useCallback } from 'react';

/**
 * useGraphData Hook - JavaScript Version
 * 
 * Manages graph data state and versioning for re-rendering
 */
export const useGraphData = (initialDataFactory) => {
  // Lazy initialization - only call the factory function once
  const [graphData, setGraphData] = useState(() => initialDataFactory());
  const [graphVersion, setGraphVersion] = useState(0);

  // Reset function that resets to default and increments version
  const resetGraph = useCallback(() => {
    const defaultGraph = initialDataFactory();
    setGraphData(defaultGraph);
    setGraphVersion(prev => prev + 1);
  }, [initialDataFactory]);

  return {
    graphData,
    setGraphData,
    graphVersion,
    setGraphVersion,
    resetGraph
  };
};
